<template>
  <div class="stats-page">
    <el-card class="box-card">
      <!-- 搜索工具栏 -->
      <div class="search-toolbar">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="投保人公司">
            <el-input v-model="searchForm.companyName" placeholder="投保人公司名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="时间">
            <el-date-picker v-model="searchForm.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"></el-date-picker>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="searchForm.mobile" placeholder="手机号" clearable></el-input>
          </el-form-item>
          <el-form-item label="渠道ID">
            <el-input v-model="searchForm.channelId" placeholder="渠道ID" clearable></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
            <el-button type="success" @click="handleExportExcel">导出Excel</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="sum-bar">
        <strong>充值总额：<span style="color: #ff7300">{{ sum | money }}</span> 元</strong>
      </div>

      <!-- 数据表格 -->
      <el-table :data="tableData" style="width: 100%" border v-loading="loading">
        <el-table-column prop="company_name" label="公司名称" width="240" align="center"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="130" align="center"></el-table-column>
        <el-table-column prop="price_name" label="价格方案" width="200" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.price_name || '干线保' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="insurance_company_name" label="保险公司" width="180" align="center"></el-table-column>
        <el-table-column prop="product_name" label="产品名称" width="180" align="center"></el-table-column>
        <el-table-column prop="source_desc" label="来源" width="160" align="center"></el-table-column>
        <el-table-column prop="amount" label="金额(元)" width="120" align="right" :formatter="moneyFormat"></el-table-column>
        <el-table-column prop="balance" label="余额(元)" width="120" align="right" :formatter="moneyFormat"></el-table-column>
        <el-table-column prop="pay_voucher_url" label="凭证" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.source === 4 && scope.row.pay_voucher_url" class="link" @click="viewVoucher(scope.row)">查看</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="时间" width="160" align="center" :formatter="dateFormat"></el-table-column>
      </el-table>
      <div style="margin-top: 10px; text-align: right;">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-sizes="[15, 30, 50, 100]"
          :page-size="rows"
          :current-page="page"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from '@/lib/request'
import { getToken } from '@/lib/local'
import ExportJsonExcel from 'js-export-excel'

export default {
  name: 'SingleTicketDepositStats',
  data() {
    return {
      loading: false,
      tableData: [],
      sum: 0,
      total: 0,
      page: 1,
      rows: 15,
      searchForm: {
        companyName: '', dateRange: [], mobile: '', channelId: ''
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    buildParams() {
      const params = { product_alias: 'product-', page: this.page, rows: this.rows }

      if (this.searchForm.companyName) params.company_name = this.searchForm.companyName
      if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        params.begin_date = Math.floor(this.searchForm.dateRange[0] / 1000)
        params.end_date = Math.floor(this.searchForm.dateRange[1] / 1000)
      }
      if (this.searchForm.mobile) params.mobile = this.searchForm.mobile
      if (this.searchForm.channelId) params.channel_id = Number(this.searchForm.channelId)
      return params
    },
    async fetchData() {
      this.loading = true
      try {
        const params = this.buildParams()
        const res = await axios.request({
          url: '/v1/admin/cmn/transaction/deposit',
          method: 'get',
          params,
          headers: { 'AppKey': 'BpLnfgDs' }
        })
        this.tableData = res.rows || []
        this.sum = Number(res.sum || 0) / 100
        this.total = Number(res.total || 0)
      } catch (e) {
        console.error('获取充值统计失败', e)
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.page = 1; this.fetchData() },
    handleReset() {
      this.searchForm = { companyName: '', dateRange: [], mobile: '', channelId: '' }
      this.page = 1
      this.rows = 15
      this.fetchData()
    },
    handlePageChange(p) { this.page = p; this.fetchData() },
    handleSizeChange(s) { this.rows = s; this.page = 1; this.fetchData() },
    handleExportExcel() {
      const data = this.tableData.map(r => ({
        '公司名称': r.company_name,
        '手机号码': r.mobile,
        '价格方案': r.price_name || '干线保',
        '保险公司': r.insurance_company_name,
        '产品名称': r.product_name,
        '来源': r.source_desc,
        '金额(元)': Number(this.moneyFormat(null, null, r.amount)),
        '余额(元)': Number(this.moneyFormat(null, null, r.balance)),
        '时间': this.dateFormat(null, null, r.created_at)
      }))
      if (!data.length) {
        this.$message.warning('没有查询到数据')
        return
      }
      const option = {
        fileName: '单票货运险充值统计',
        datas: [{ sheetData: data, sheetName: 'sheet', sheetHeader: ['公司名称','手机号码','价格方案','保险公司','产品名称','来源','金额(元)','余额(元)','时间'] }]
      }
      const toExcel = new ExportJsonExcel(option)
      toExcel.saveExcel()
    },
    // Element-UI formatter 签名：(row, column, cellValue)
    dateFormat(row, column, cellValue) {
      const ts = cellValue
      if (!ts && ts !== 0) return ''
      let ms = ts
      if (typeof ts === 'number') {
        ms = ts > 1e12 ? ts : ts * 1000
      } else if (typeof ts === 'string') {
        const num = Number(ts)
        if (!isNaN(num)) ms = num > 1e12 ? num : num * 1000
        else ms = ts
      }
      const d = new Date(ms)
      if (isNaN(d.getTime())) return ''
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hh = String(d.getHours()).padStart(2, '0')
      const mm = String(d.getMinutes()).padStart(2, '0')
      const ss = String(d.getSeconds()).padStart(2, '0')
      return `${y}-${m}-${day} ${hh}:${mm}:${ss}`
    },
    moneyFormat(row, column, cellValue) {
      const v = cellValue
      if (v == null) return ''
      return (Number(v) / 100).toFixed(2)
    },
    typeFormat(row, column, cellValue) {
      const t = cellValue
      if (t === 1) return '充值'
      if (t === 2) return '投保'
      if (t === 4) return '红包抵扣'
      if (t === 64) return '退款'
      return ''
    },
    viewVoucher(row) {
      const url = row.pay_voucher_url
      if (url) window.open(url)
    }
  },
  filters: { money(v) { return Number(v).toFixed(2) } }
}
</script>

<style scoped>
.search-toolbar { margin-bottom: 10px; }
.sum-bar { margin: 8px 0; }
</style>
